import * as React from "react";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { IExtLinkLocalization } from "../../../models/localization";
import { Grid, Row, Col } from "react-flexbox-grid";
import Button from 'material-ui/Button';
import CheckBox from "material-ui/Checkbox";
import { FormControlLabel } from "material-ui/Form";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withMobileDialog,
} from 'material-ui/Dialog';

@inject("store") @observer
export default class ExternalLinkDlg extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  handleClose = (): void => {
    this.props.store.viewState.setShowExternalLink(false);
  }
  handleAccept = (): void => {
    // navigate to link
    if (this.props.store.viewState.externalLinkUrl) {
      window.open(this.props.store.viewState.externalLinkUrl, "_blank");
    }
    this.props.store.viewState.setShowExternalLink(false);
  }
  render(): JSX.Element {
    if (!this.props.store.localization.fields) {
      return null;
    }
    const local: IExtLinkLocalization = this.props.store.localization.fields.extLink;
    if (!this.props.store.viewState.showExternalLink) {
      return null;
    }
    const checked: any = { color: "#5B6770" };
    return (<Dialog
      fullScreen={false}
      open={true}
      onClose={this.handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">{local.title}</DialogTitle>
      <DialogContent>
        <Grid>
          <Row>
            <Col xs={12}>
              {local.message}
            </Col>
            <Col xs={12}>
              <FormControlLabel label={local.hide} control={<CheckBox style={checked} checked={this.props.store.viewState.externalLinkIgnore}
                onChange={(e: object, chk: boolean) => this.props.store.viewState.setIgnoreLinkPrompt(chk)} />} />
            </Col>
          </Row>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={this.handleClose} color="secondary">{local.cancel}</Button>
        <Button onClick={this.handleAccept} color="secondary">{local.ok}</Button>
      </DialogActions>
    </Dialog>);
  }
}


// WEBPACK FOOTER //
// ./src/components/dialogs/externalLink/index.tsx